import FrameConfig from "@lib/classes/FrameConfig";
import Session from "@lib/session";
import Cookies from "js-cookie";
import router from "next/router";
import {
  LogoutProfileDocument,
  LogoutProfileMutationResult,
  LogoutProfileMutationVariables,
} from "@graphql/api";

export default async function logoutProfile(type: string): Promise<void> {
  const client = global.window.apolloClient;

  const mutVars: LogoutProfileMutationVariables = { type };
  const result: LogoutProfileMutationResult = await client.mutate({
    mutation: LogoutProfileDocument,
    variables: mutVars,
  });

  if (result.data.logoutProfile.error) {
    console.error(result.data.logoutProfile.error);
    return;
  }

  // Update the session profiles object.
  type ProfilesKey = keyof be.Profiles;
  let profiles = Session.getBooking().profiles;
  const profileKeyMap: { [key: string]: ProfilesKey } = {
    CHARTER: "charter",
    COUPON: "coupon",
    SALES: "sales",
    USER: "user",
    GROUP: "group",
  };
  const profileKey: ProfilesKey | undefined = profileKeyMap[type];
  if (profileKey) {
    if (profileKey == "group" || profileKey == "coupon") {
      profiles[`${profileKey}Web`] = undefined;
      profiles.group = undefined;
      profiles.coupon = undefined;
    } else {
      profiles[profileKey] = undefined;
    }
  }
  if (type == "ALL") profiles = {};
  Session.updateBooking({ profiles });

  if (type == "GROUP" || type == "ALL" || type == "COUPON") {
    Cookies.remove(`b_${router.query.siteId}_gi`);
    new FrameConfig().update("groupCode", undefined);
  }
}
